import React, {useEffect} from 'react';
import {useIntl} from 'react-intl';
import * as _ from 'lodash';
import {StyledFieldRadiobutton} from '../FieldRadiobutton';
import {StyledFieldDatepicker} from '../FieldDatepicker';
import {StyledFieldInput} from '../FieldInput';
import {InputCheckbox} from '../FieldCheckbox';
import AddStreetPopup from '../AddStreetPopup/AddStreetPopup';
import Unit from '../Unit';
import {integerValue} from '../../../../../utils/format';
import {useCitiesContext, useStreetsContext} from '../CitiesAndStreets';
import {useDecisionTreeOptionsContext, useDecisionTreeShumaTypesOptionsContext} from '../DecisionTreeOptions';
import {usePageContext} from "../../../PriceQuoteDetails/contexts/PageContext";
import {FormikSelect} from "../FormikSelect/FormikSelect";
import {useTempInspectionsListContext} from "../../../PriceQuoteDetails/contexts/TempInspectionsListContext";
import PopupPriceCatalog from "../../../PriceQuoteDetails/components/PopupPriceCatalog/PopupPriceCatalog";
import {PopupPriceCatalogProvider} from "../../../PriceQuoteDetails/contexts/PopupPriceCatalogContext";

const TempInspectionFrom = ({
                              index,
                              values,
                              fieldNames,
                              setFieldValue,
                              handleChange,
                              decisionTreeProps,
                              disabledFormCondition
                            }) => {
  const {users} = usePageContext();
  const {cities} = useCitiesContext();
  const {streets, updateStreets} = useStreetsContext();
  const {
    reasons,
    banks,
    propertyTypes,
    loanTypes,
    loanSubTypes,
    shumaMazminIdentities
  } = useDecisionTreeOptionsContext();
  const {shumaTypes, updateShumaTypes} = useDecisionTreeShumaTypesOptionsContext();
  const {
    decisionTree,
    decisionTreeOptions,
    handleResetDecisionTree,
    handleResetPreviousSteps,
  } = decisionTreeProps;
  const prefix = 'tab-order-inspections-field-label';
  const {formatMessage} = useIntl();
  const {formikTempInspections} = useTempInspectionsListContext();

  const {
    propertyTypeIDRightsEstimation,
    bankID,
    shumaTypeID,
    propertyTypeID,
    loanTypeID,
    loanText,
    otherPropertyTypeID,
    shumaReasonID,
    bankBranchNumber,
    bankBranchName,
    bankClerkFullName,
    bankEmail,
    bankRequestID,
    bankBuildType,
    responsibleUser,
    dueDate,
    city,
    gush,
    street,
    helka,
    houseNumber,
    ttHelka,
    apartmentNumber,
    landLotNum,
    landLotNumAccordingTaba,
    notes,
    loanSubTypeID,
    shumaMazminIdentityID,
    underConstruction,
    tempShumaID,
    purchaseCompensation
  } = fieldNames;

  const showSection = (fieldId) => {
    switch (fieldId) {
      case (propertyTypeIDRightsEstimation):
        return _.get(values, shumaReasonID) === decisionTree.rightsEstimation;
      case (bankID):
        return _.get(values, shumaReasonID) === decisionTree.bankSecure;
      case (shumaTypeID):
        return (
          _.get(values, shumaReasonID) === decisionTree.rightsEstimation ||
          _.get(values, shumaReasonID) === decisionTree.bankSecure
        );
      case (propertyTypeID):
        return Boolean(_.get(values, bankID)) && Boolean(_.get(values, shumaTypeID));
      case (loanTypeID):
        return Boolean(_.get(values, bankID))
          && Boolean(_.get(values, shumaTypeID))
          && Boolean(_.get(values, propertyTypeID));
      case (loanSubTypeID):
        return Boolean(_.get(values, loanTypeID));
      case (loanText):
        if (_.get(values, loanTypeID)) {
          return _.get(values, loanTypeID).toString() === decisionTree.loanTypeID.another;
        } else return null;
      case (otherPropertyTypeID):
        if (_.get(values, loanTypeID)) {
          return _.get(values, loanTypeID).toString() === decisionTree.loanTypeID.other;
        } else return null;
      default:
        return true;
    }
  };

  const commonSelectProps = {
    isAsync: true,
    menuIsOpen: disabledFormCondition ? false : undefined,
    disabled: disabledFormCondition,
    isSearchable: true,
    customContainerStyles: 'mx-2 mb-3 w-250px',
    formik: formikTempInspections
  };
  const commonInputProps = {
    customContainerStyles: 'mx-2 mb-3 w-250px',
    disabled: disabledFormCondition
  };

  const handleCityChange = (selected) => {
    if (!values.city || values.city !== selected) {
      setFieldValue(street, null);
      if (Boolean(selected)) {
        setFieldValue(city, selected);
        updateStreets(selected).catch(console.error);
      }
    }
  };

  const handleShumaReasonChange = (selected) => {
    if (!values.shumaReasonID || values.shumaReasonID !== selected) {
      setFieldValue(shumaTypeID, null);
      if (Boolean(selected)) {
        updateShumaTypes(parseInt(selected, 10)).catch(console.error);
      }
    }
  };

  useEffect(() => {
    if (_.get(values, shumaReasonID)) {
      updateShumaTypes(parseInt(_.get(values, shumaReasonID), 10)).catch(console.error);
    }
    if (_.get(values, city)) {
      updateStreets(parseInt(_.get(values, city), 10))
    }
  }, [])
  const reason_valueOfRights = reasons[0]?.value?.toString() || '1';
  const reason_bankGuarantee = reasons[1]?.value?.toString() || '2';

  return (
    <div style={{height: 'calc(100vh - 390px)', overflowY: 'auto'}}>
      <div className={'d-flex justify-content-between w-100 mb-4'}>
        <Unit
          text={formatMessage({id: 'tab-order-inspections-header-mainParameters', defaultMessage: 'Main parameters'})}
          icon={'/media/common/Decision-tree_orange.svg'}
          customClassnames={'mr-4 w-100 position-relative'}
        >
          <PopupPriceCatalogProvider index={index} tempShumaID={_.get(values, tempShumaID)}>
            <PopupPriceCatalog
              tempShumaID={_.get(values, tempShumaID)}
              index={index}
              buttonIsLink={true}
              buttonStyles={{position: 'absolute', top: '20px', left: '20px'}}
            />
          </PopupPriceCatalogProvider>
          <div className={'w-800px mx-auto'}>
            <div className={'d-flex align-items-center justify-content-center mb-2'}>
              <StyledFieldRadiobutton
                variant={'dot'}
                fieldId={shumaReasonID}
                value={reason_bankGuarantee}
                selected={_.get(values, shumaReasonID)}
                label={formatMessage({id: `${prefix}-bankGuarantee`, defaultMessage: 'Bank guarantee'})}
                icon={<i className={`la la-bank h1 text-dark rounded`}/>}
                customContainerStyles={'mr-8'}
                onChange={(value) => {
                  setFieldValue(shumaReasonID, value);
                  handleResetDecisionTree(value, fieldNames);
                  handleShumaReasonChange(value);
                }}
                disabled={decisionTreeOptions.disabled.includes(shumaReasonID) || disabledFormCondition}
              />
              <StyledFieldRadiobutton
                variant={'dot'}
                fieldId={shumaReasonID}
                value={reason_valueOfRights}
                selected={_.get(values, shumaReasonID)}
                label={formatMessage({id: `${prefix}-valueOfRights`, defaultMessage: 'Value of rights'})}
                icon={<i className={`la la-home h1 text-dark rounded`}/>}
                onChange={(value) => {
                  setFieldValue(shumaReasonID, value);
                  handleResetDecisionTree(value, fieldNames);
                  handleShumaReasonChange(value);
                }}
                disabled={decisionTreeOptions.disabled.includes(shumaReasonID)
                  || disabledFormCondition}
              />
            </div>
            <div className={'d-flex align-items-center'}>
              {showSection(shumaTypeID) && _.get(values, shumaReasonID) === '1' && (
                <>
                  <FormikSelect
                    name={shumaTypeID}
                    options={decisionTreeOptions.disabled.includes(shumaTypeID) ? [] : shumaTypes ? shumaTypes : []}
                    onChange={(value) => {
                      handleResetPreviousSteps(shumaTypeID, value, fieldNames, values);
                      const isDisabled = decisionTreeOptions.disabled.includes(shumaTypeID);
                      setFieldValue(shumaTypeID, isDisabled ? null : value);
                    }}
                    label={
                      <div>
                        {formatMessage({id: `${prefix}-shumaType`, defaultMessage: 'Shuma type'})}
                        <span className={'text-danger'}>*</span>
                      </div>
                    }
                    {...commonSelectProps}
                  />
                </>
              )}
              {showSection(propertyTypeIDRightsEstimation) && (
                <div className={'d-flex align-items-end'}>
                  <FormikSelect
                    name={propertyTypeID} options={propertyTypes}
                    label={(
                      <div>
                        {formatMessage({id: `${prefix}-propertyType`, defaultMessage: 'Property type'})}
                        <span className={'text-danger'}>*</span>
                      </div>
                    )}
                    {...commonSelectProps}
                  />
                  <InputCheckbox
                    fieldId={underConstruction}
                    label={formatMessage({id: `${prefix}-underConstruction`, defaultMessage: 'Under construction',})}
                    customContainerStyles={'mb-6 mx-2 w-250px'}
                    onChange={() => setFieldValue(underConstruction, !_.get(values, underConstruction))}
                    value={_.get(values, underConstruction)}
                  />
                </div>
              )}
            </div>
            {showSection(bankID) && (
              <div className={'d-flex flex-column'}>
                <FormikSelect
                  name={bankID} options={banks}
                  onChange={(value) => {
                    handleResetPreviousSteps(bankID, value, fieldNames, values);
                    setFieldValue(bankID, value);
                  }}
                  label={(
                    <div>
                      {formatMessage({id: `${prefix}-bank`, defaultMessage: 'Bank'})}
                      <span className={'text-danger'}>*</span>
                    </div>
                  )}
                  {...commonSelectProps}
                />
                <div className={'d-flex'}>
                  <StyledFieldInput
                    fieldId={bankBranchNumber}
                    label={formatMessage({
                      id: `${prefix}-bankBranchNumber`,
                      defaultMessage: 'Bank branch number'
                    })}
                    value={_.get(values, bankBranchNumber)}
                    onChange={(e) => setFieldValue(bankBranchNumber, integerValue(e))}
                    icon={'/media/common/Number_primary.svg'}
                    {...commonInputProps}
                  />
                  <StyledFieldInput
                    fieldId={bankBranchName}
                    label={formatMessage({id: `${prefix}-bankBranchName`, defaultMessage: 'Bank branch name'})}
                    value={_.get(values, bankBranchName)}
                    onChange={handleChange}
                    icon={'/media/common/Bank_primary.svg'}
                    {...commonInputProps}
                  />
                  <StyledFieldInput
                    fieldId={bankClerkFullName}
                    label={formatMessage({
                      id: `${prefix}-bankClerkFullName`,
                      defaultMessage: 'Bank clerk full name'
                    })}
                    value={_.get(values, bankClerkFullName)}
                    onChange={handleChange}
                    icon={'/media/common/User_primary.svg'}
                    {...commonInputProps}
                  />
                </div>
                <div className={'d-flex'}>
                  <StyledFieldInput
                    fieldId={bankEmail}
                    type={'email'}
                    label={formatMessage({id: `${prefix}-bankEmail`, defaultMessage: 'Bank email'})}
                    value={_.get(values, bankEmail)}
                    onChange={handleChange}
                    icon={'/media/common/Email_primary.svg'}
                    {...commonInputProps}
                  />
                  <StyledFieldInput
                    fieldId={bankRequestID}
                    label={formatMessage({id: `${prefix}-bankRequestID`, defaultMessage: 'Bank request ID'})}
                    value={_.get(values, bankRequestID)}
                    onChange={handleChange}
                    icon={'/media/common/Request_primary.svg'}
                    {...commonInputProps}
                  />
                  <StyledFieldInput
                    fieldId={bankBuildType}
                    label={formatMessage({id: `${prefix}-bankBuildType`, defaultMessage: 'Bank build type'})}
                    value={_.get(values, bankBuildType)}
                    onChange={handleChange}
                    icon={'/media/common/Type_primary.svg'}
                    {...commonInputProps}
                  />
                </div>
                <div className={'d-flex align-items-center'}>
                  {showSection(shumaTypeID) && _.get(values, shumaReasonID) === '2' && (
                    <FormikSelect
                      name={shumaTypeID}
                      options={decisionTreeOptions.disabled.includes(shumaTypeID) ? [] : shumaTypes}
                      onChange={(value) => {
                        handleResetPreviousSteps(shumaTypeID, value, fieldNames, values);
                        const isDisabled = decisionTreeOptions.disabled.includes(shumaTypeID)
                        setFieldValue(shumaTypeID, isDisabled ? null : value);
                      }}
                      label={
                        <div>
                          {formatMessage({id: `${prefix}-shumaType`, defaultMessage: 'Shuma type'})}
                          <span className={'text-danger'}>*</span>
                        </div>
                      }
                      {...commonSelectProps}
                    />
                  )}
                  {showSection(propertyTypeID) && (
                    <div className={'d-flex align-items-end'}>
                      <FormikSelect
                        name={propertyTypeID}
                        options={decisionTreeOptions.disabled.includes(propertyTypeID) ? [] : propertyTypes}
                        onChange={(value) => {
                          handleResetPreviousSteps(propertyTypeID, value, fieldNames, values);
                          const isDisabled = decisionTreeOptions.disabled.includes(propertyTypeID);
                          setFieldValue(propertyTypeID, isDisabled ? null : value);
                        }}
                        label={
                          <div>
                            {formatMessage({id: `${prefix}-propertyType`, defaultMessage: 'Property type'})}
                            <span className={'text-danger'}>*</span>
                          </div>
                        }
                        {...commonSelectProps}
                      />
                      <InputCheckbox
                        fieldId={underConstruction}
                        label={formatMessage({id: `${prefix}-underConstruction`, defaultMessage: 'Under construction'})}
                        onChange={() => setFieldValue(underConstruction, !_.get(values, underConstruction))}
                        value={_.get(values, underConstruction)}
                        customContainerStyles={'mb-6 mx-2 w-250px'}
                      />
                    </div>
                  )}
                </div>
                <div className={'d-flex align-items-center'}>
                  {showSection(loanTypeID) && (
                    <FormikSelect
                      name={loanTypeID} options={loanTypes}
                      label={formatMessage({id: `${prefix}-loanType`, defaultMessage: 'Loan type'})}
                      {...commonSelectProps}
                    />
                  )}
                  {showSection(loanSubTypeID) && (
                    <FormikSelect
                      name={loanSubTypeID} options={loanSubTypes}
                      label={formatMessage({id: `${prefix}-loanSubType`, defaultMessage: 'Loan sub type'})}
                      {...commonSelectProps}
                    />
                  )}
                  {showSection(otherPropertyTypeID) && (
                    <FormikSelect
                      name={otherPropertyTypeID} options={propertyTypes}
                      label={(
                        <div>
                          {formatMessage({id: `${prefix}-loanPropertyType`, defaultMessage: 'Loan property type'})}
                          <span className={'text-danger'}>*</span>
                        </div>
                      )}
                      {...commonSelectProps}
                    />
                  )}
                  {showSection(loanText) && (
                    <StyledFieldInput
                      fieldId={loanText}
                      value={_.get(values, loanText)}
                      label={(
                        <div>
                          {formatMessage({id: `${prefix}-loanText`, defaultMessage: 'Loan text'})}
                          <span className={'text-danger'}>*</span>
                        </div>
                      )}
                      onChange={handleChange}
                      icon={'/media/common/Edit_primary.svg'}
                      {...commonInputProps}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        </Unit>
        <Unit
          text={formatMessage({id: 'tab-order-inspections-header-general', defaultMessage: 'General'})}
          icon={'/media/common/General_navy.svg'}
        >
          <div className={'d-flex flex-column align-items-center'}>
            <FormikSelect
              name={responsibleUser} options={users}
              label={
                <div>
                  {formatMessage({id: `${prefix}-responsibleUser`, defaultMessage: 'Firm user'})}
                  <span className={'text-danger'}>*</span>
                </div>
              }
              {...commonSelectProps}
              customContainerStyles={'w-250px mb-3'}
            />
            <StyledFieldDatepicker
              label={formatMessage({id: 'tab-order-general-field-label-dueDate', defaultMessage: 'Due date'})}
              value={_.get(values, dueDate)}
              onChange={(date) => setFieldValue(dueDate, date)}
              {...commonInputProps}
              customContainerStyles={'w-250px mb-3'}
            />
            <FormikSelect
              name={shumaMazminIdentityID} options={shumaMazminIdentities}
              label={
                <div>
                  {formatMessage({id: `${prefix}-shumaMazminIdentityID`, defaultMessage: 'Shuma mazmin identity'})}
                  <span className={'text-danger'}>*</span>
                </div>
              }
              {...commonSelectProps}
              customContainerStyles={'w-250px mb-3'}
            />
            <StyledFieldInput
              fieldId={purchaseCompensation}
              value={_.get(values, purchaseCompensation)}
              label={formatMessage({id: `${prefix}-purchaseCompensation`, defaultMessage: 'Purchase compensation'})}
              onChange={handleChange}
              icon={'/media/common/Money_primary.svg'}
              {...commonInputProps}
              customContainerStyles={'w-250px mx-2'}
            />
            <div className={'w-250px mx-2'}/>
            <div className={'w-250px mx-2'}/>
          </div>
        </Unit>
      </div>
      <div>
        <Unit
          text={formatMessage({id: 'tab-order-inspections-header-propertyDetails', defaultMessage: 'Property details'})}
          icon={'/media/common/Address_green.svg'}
          customClassnames={'mb-4'}
        >
          <div className={'d-flex align-items-end justify-content-between'}>
            <FormikSelect
              name={city} options={cities}
              onChange={(value) => {
                handleCityChange(value);
              }}
              label={formatMessage({id: `${prefix}-city`, defaultMessage: 'City'})}
              {...commonSelectProps}
              customContainerStyles={'w-250px mx-2'}
            />
            <FormikSelect
              name={street} options={streets || []}
              label={
                <div className="d-flex align-items-center">
                  <div className="d-inline-block pr-3">
                    {formatMessage({id: `${prefix}-street`, defaultMessage: 'Street'})}
                  </div>
                  <AddStreetPopup
                    cityID={_.get(values, city)}
                    onSubmit={async (selected) => {
                      await setFieldValue(street, selected.value);
                    }}
                    buttonDisabled={!_.get(values, city)}
                  />
                </div>
              }
              disabled={!_.get(values, city)}
              {...commonSelectProps}
              customContainerStyles={'w-250px mx-2'}
            />
            <StyledFieldInput
              fieldId={houseNumber}
              value={_.get(values, houseNumber)}
              label={formatMessage({id: `${prefix}-houseNumber`, defaultMessage: 'House number'})}
              onChange={(e) => setFieldValue(houseNumber, integerValue(e))}
              icon={'/media/common/Home_primary.svg'}
              {...commonInputProps}
              customContainerStyles={'w-250px mx-2'}
            />
            <StyledFieldInput
              fieldId={apartmentNumber}
              value={_.get(values, apartmentNumber)}
              label={formatMessage({id: `${prefix}-apartmentNumber`, defaultMessage: 'Apartment number'})}
              onChange={(e) => setFieldValue(apartmentNumber, integerValue(e))}
              icon={'/media/common/Door_primary.svg'}
              {...commonInputProps}
              customContainerStyles={'w-250px mx-2'}
            />
            <StyledFieldInput
              fieldId={notes}
              value={_.get(values, notes)}
              label={formatMessage({id: `${prefix}-notes`, defaultMessage: 'Notes'})}
              onChange={handleChange}
              icon={'/media/common/Edit_primary.svg'}
              {...commonInputProps}
              customContainerStyles={'w-250px mx-2'}
            />
          </div>
        </Unit>
        <Unit
          text={formatMessage({id: 'tab-order-inspections-header-lot', defaultMessage: 'Lot'})}
          icon={'/media/common/Geo_red.svg'}
          customClassnames={'mb-4'}
        >
          <div className={'d-flex align-items-center justify-content-between'}>
            <StyledFieldInput
              fieldId={gush}
              value={_.get(values, gush)}
              label={formatMessage({id: `${prefix}-gush`, defaultMessage: 'Gush'})}
              onChange={(e) => setFieldValue(gush, integerValue(e))}
              icon={'/media/common/Map_primary.svg'}
              {...commonInputProps}
              customContainerStyles={'w-250px mx-2'}
            />
            <StyledFieldInput
              fieldId={helka}
              value={_.get(values, helka)}
              label={formatMessage({id: `${prefix}-helka`, defaultMessage: 'Helka'})}
              onChange={(e) => setFieldValue(helka, integerValue(e))}
              icon={'/media/common/Map_primary.svg'}
              {...commonInputProps}
              customContainerStyles={'w-250px mx-2'}
            />
            <StyledFieldInput
              fieldId={ttHelka}
              value={_.get(values, ttHelka)}
              label={formatMessage({id: `${prefix}-ttHelka`, defaultMessage: 'ttHelka'})}
              onChange={(e) => setFieldValue(ttHelka, integerValue(e))}
              icon={'/media/common/Map_primary.svg'}
              {...commonInputProps}
              customContainerStyles={'w-250px mx-2'}
            />
            <StyledFieldInput
              fieldId={landLotNum}
              value={_.get(values, landLotNum)}
              label={formatMessage({id: `${prefix}-landLotNum`, defaultMessage: 'Land lot number'})}
              onChange={handleChange}
              icon={'/media/common/Rooms_primary.svg'}
              {...commonInputProps}
              customContainerStyles={'w-250px mx-2'}
            />
            <StyledFieldInput
              fieldId={landLotNumAccordingTaba}
              value={_.get(values, landLotNumAccordingTaba)}
              label={formatMessage({
                id: `${prefix}-landLotNumbAccordingTaba`,
                defaultMessage: 'Land lot number according taba'
              })}
              onChange={handleChange}
              icon={'/media/common/Number_primary.svg'}
              {...commonInputProps}
              customContainerStyles={'w-250px mx-2'}
            />
          </div>
        </Unit>
      </div>
    </div>
  );
};

export default TempInspectionFrom;